var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Box',{staticClass:"no-data-placeholder"},[_c('BIcon',{attrs:{"icon":"inbox","custom-class":"fa-4x"}}),_c('Title',[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }